/**
 * Translation-key catalogs for the Valorization recommendations methodology guide.
 * Thresholds used in criterion/example interpolations live in buildValorizationRecommendations.js.
 */

export const VALORIZATION_RECOMMENDATION_CATALOG = [
  {
    id: "no-valorisable-config",
    severity: "high",
    scenarioTitleKey: "valorizationRecoGuide.config.scenarioTitle",
    scenarioDescriptionKey: "valorizationRecoGuide.config.scenarioDescription",
    criterionKey: "valorizationRecoGuide.config.criterion",
    exampleKey: "valorizationRecoGuide.config.example",
    recommendationKey: "valorizationRecoGuide.config.recommendation",
  },
  {
    id: "volume-frein",
    severity: "high",
    scenarioTitleKey: "valorizationRecoGuide.volumeFrein.scenarioTitle",
    scenarioDescriptionKey:
      "valorizationRecoGuide.volumeFrein.scenarioDescription",
    criterionKey: "valorizationRecoGuide.volumeFrein.criterion",
    exampleKey: "valorizationRecoGuide.volumeFrein.example",
    recommendationKey: "valorizationRecoGuide.volumeFrein.recommendation",
  },
  {
    id: "quality-frein",
    severity: "high",
    scenarioTitleKey: "valorizationRecoGuide.qualityFrein.scenarioTitle",
    scenarioDescriptionKey:
      "valorizationRecoGuide.qualityFrein.scenarioDescription",
    criterionKey: "valorizationRecoGuide.qualityFrein.criterion",
    exampleKey: "valorizationRecoGuide.qualityFrein.example",
    recommendationKey: "valorizationRecoGuide.qualityFrein.recommendation",
  },
  {
    id: "source-separation-high",
    severity: "high",
    scenarioTitleKey:
      "valorizationRecoGuide.sourceSeparationHigh.scenarioTitle",
    scenarioDescriptionKey:
      "valorizationRecoGuide.sourceSeparationHigh.scenarioDescription",
    criterionKey: "valorizationRecoGuide.sourceSeparationHigh.criterion",
    exampleKey: "valorizationRecoGuide.sourceSeparationHigh.example",
    recommendationKey:
      "valorizationRecoGuide.sourceSeparationHigh.recommendation",
  },
  {
    id: "source-separation-medium",
    severity: "medium",
    scenarioTitleKey:
      "valorizationRecoGuide.sourceSeparationMedium.scenarioTitle",
    scenarioDescriptionKey:
      "valorizationRecoGuide.sourceSeparationMedium.scenarioDescription",
    criterionKey: "valorizationRecoGuide.sourceSeparationMedium.criterion",
    exampleKey: "valorizationRecoGuide.sourceSeparationMedium.example",
    recommendationKey:
      "valorizationRecoGuide.sourceSeparationMedium.recommendation",
  },
  {
    id: "reduce-sorting-high",
    severity: "high",
    scenarioTitleKey: "valorizationRecoGuide.reduceSortingHigh.scenarioTitle",
    scenarioDescriptionKey:
      "valorizationRecoGuide.reduceSortingHigh.scenarioDescription",
    criterionKey: "valorizationRecoGuide.reduceSortingHigh.criterion",
    exampleKey: "valorizationRecoGuide.reduceSortingHigh.example",
    recommendationKey: "valorizationRecoGuide.reduceSortingHigh.recommendation",
  },
  {
    id: "reduce-sorting-medium",
    severity: "medium",
    scenarioTitleKey: "valorizationRecoGuide.reduceSortingMedium.scenarioTitle",
    scenarioDescriptionKey:
      "valorizationRecoGuide.reduceSortingMedium.scenarioDescription",
    criterionKey: "valorizationRecoGuide.reduceSortingMedium.criterion",
    exampleKey: "valorizationRecoGuide.reduceSortingMedium.example",
    recommendationKey:
      "valorizationRecoGuide.reduceSortingMedium.recommendation",
  },
  {
    id: "close-gap-high",
    severity: "high",
    scenarioTitleKey: "valorizationRecoGuide.closeGapHigh.scenarioTitle",
    scenarioDescriptionKey:
      "valorizationRecoGuide.closeGapHigh.scenarioDescription",
    criterionKey: "valorizationRecoGuide.closeGapHigh.criterion",
    exampleKey: "valorizationRecoGuide.closeGapHigh.example",
    recommendationKey: "valorizationRecoGuide.closeGapHigh.recommendation",
  },
  {
    id: "close-gap-medium",
    severity: "medium",
    scenarioTitleKey: "valorizationRecoGuide.closeGapMedium.scenarioTitle",
    scenarioDescriptionKey:
      "valorizationRecoGuide.closeGapMedium.scenarioDescription",
    criterionKey: "valorizationRecoGuide.closeGapMedium.criterion",
    exampleKey: "valorizationRecoGuide.closeGapMedium.example",
    recommendationKey: "valorizationRecoGuide.closeGapMedium.recommendation",
  },
  {
    id: "maintain",
    severity: "watch",
    scenarioTitleKey: "valorizationRecoGuide.maintain.scenarioTitle",
    scenarioDescriptionKey:
      "valorizationRecoGuide.maintain.scenarioDescription",
    criterionKey: "valorizationRecoGuide.maintain.criterion",
    exampleKey: "valorizationRecoGuide.maintain.example",
    recommendationKey: "valorizationRecoGuide.maintain.recommendation",
  },
];

export const VALORIZATION_FORMULA_ROWS = [
  {
    id: "rate",
    labelKey: "valorizationRecoGuide.formula.rate.label",
    formulaKey: "valorizationRecoGuide.formula.rate.formula",
  },
  {
    id: "share",
    labelKey: "valorizationRecoGuide.formula.share.label",
    formulaKey: "valorizationRecoGuide.formula.share.formula",
  },
  {
    id: "sortingRate",
    labelKey: "valorizationRecoGuide.formula.sortingRate.label",
    formulaKey: "valorizationRecoGuide.formula.sortingRate.formula",
  },
  {
    id: "sortingGain",
    labelKey: "valorizationRecoGuide.formula.sortingGain.label",
    formulaKey: "valorizationRecoGuide.formula.sortingGain.formula",
  },
  {
    id: "thresholds",
    labelKey: "valorizationRecoGuide.formula.thresholds.label",
    formulaKey: "valorizationRecoGuide.formula.thresholds.formula",
  },
];
